
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySafeWater as ObiSimplifiedBuoySafeWaterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-safe-water.js';
 
 
 

 
 export const ObiSimplifiedBuoySafeWater = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-safe-water',
   elementClass: ObiSimplifiedBuoySafeWaterElement,
   events: {
     
   }
  });
 
 